import { Mail, Linkedin, Github, Globe, ArrowUpRight } from "lucide-react";
import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";
import { contactLinks } from "../../data/content";

export default function Contact() {
  const { t } = useApp();

  const items = [
    { icon: Mail, label: t("contact.email"), href: `mailto:${contactLinks.email}`, external: false },
    { icon: Linkedin, label: t("contact.linkedin"), href: contactLinks.linkedin, external: true },
    { icon: Github, label: t("contact.github"), href: contactLinks.github, external: true },
    { icon: Globe, label: t("contact.portfolio"), href: contactLinks.portfolio, external: true },
  ];

  return (
    <Section id="contact">
      <div className="relative overflow-hidden rounded-[2rem] border border-soft bg-gradient-to-br from-cyan-500/[0.08] via-transparent to-purple-500/[0.08] p-6 text-center sm:p-12">
        <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 rounded-full bg-cyan-500/20 blur-[100px]" />
        <div className="relative mx-auto max-w-2xl">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full border border-soft px-3 py-1 text-xs font-semibold uppercase tracking-widest text-cyan-400">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" />
            {t("contact.tag")}
          </span>
          <h2 className="font-display text-3xl font-bold sm:text-4xl">{t("contact.title")}</h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-soft">{t("contact.subtitle")}</p>

          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {items.map((item) => (
              <a
                key={item.label}
                href={item.href}
                {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="group inline-flex items-center justify-between gap-3 rounded-xl border border-soft card-bg px-5 py-4 text-sm font-semibold transition-all hover:-translate-y-0.5 hover:border-cyan-400/50 hover:text-cyan-400"
              >
                <span className="inline-flex items-center gap-3">
                  <item.icon className="h-5 w-5 text-cyan-400" />
                  {item.label}
                </span>
                <ArrowUpRight className="h-4 w-4 text-soft transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
